import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  AfterViewInit,
  Input,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CodecraftAnswer,
  CodecraftQuestion,
} from '@codecraft-works/data-models';

@Component({
  standalone: true,
  selector: 'codecraft-quiz-boolean-answer-question',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section *ngIf="questionForm && question" [formGroup]="questionForm">
      <p>
        {{ question.prompt }}
      </p>
      <div>
        <label>
          <input
            [id]="'question_true'"
            formControlName="question"
            type="radio"
            value="true"
          />
          True
          <ng-container *ngIf="correctQuestionData">
            <ng-container *ngIf="correctQuestionData.correctAnswer === true"
              ><span class="badge badge-success">Correct choice!</span>
            </ng-container>
            <ng-container
              *ngIf="
                !correctQuestionData.isCorrect &&
                questionForm.controls.question.value === 'true'
              "
              ><span class="badge badge-danger">Incorrect choice!</span>
            </ng-container>
          </ng-container>
        </label>
      </div>
      <div>
        <label>
          <input
            [id]="'question_false'"
            formControlName="question"
            type="radio"
            value="false"
          />
          False
          <ng-container *ngIf="correctQuestionData">
            <ng-container *ngIf="correctQuestionData.correctAnswer === false"
              ><span class="badge badge-success">Correct choice!</span>
            </ng-container>
            <ng-container
              *ngIf="
                !correctQuestionData.isCorrect &&
                questionForm.controls.question.value === 'false'
              "
              ><span class="badge badge-danger">Incorrect choice!</span>
            </ng-container>
          </ng-container>
        </label>
      </div>
    </section>

    <div
      class="alert alert-success"
      *ngIf="correctQuestionData && correctQuestionData.isCorrect"
    >
      Correct Answer!
    </div>
    <div
      class="alert alert-danger"
      *ngIf="correctQuestionData && !correctQuestionData.isCorrect"
    >
      Incorrect Answer!
    </div>
  `,
  styles: [
    `
      div.alert {
        color: white;
        max-width: fit-content;
      }
    `,
  ],
  imports: [NgIf, ReactiveFormsModule],
})
export class CodecraftQuizBooleanAnswerQuestionComponent
  implements AfterViewInit
{
  @Input() question: CodecraftQuestion | undefined;
  @Input() questionForm: FormGroup | undefined;
  @Input() correctQuestionData:
    | {
        isCorrect: boolean;
        correctAnswer: CodecraftAnswer;
      }
    | undefined;
  @Input() answerGiven: CodecraftAnswer | undefined;

  ngAfterViewInit(): void {
    if (this.answerGiven !== undefined) {
      const trueInput = document.getElementById(
        'question_true'
      ) as HTMLInputElement;
      const falseInput = document.getElementById(
        'question_false'
      ) as HTMLInputElement;
      if (trueInput) trueInput.checked = this.answerGiven === true;
      trueInput.readOnly = true;
      if (falseInput) falseInput.checked = this.answerGiven === false;
      falseInput.readOnly = true;
    }
  }
}
